import React, { useState } from 'react';
import Modal from './Modal';

const RoleModal = ({ open, onClose, onSubmit, username }) => {
  const [role, setRole] = useState('');
  return (
    <Modal open={open} onClose={onClose} title={`Set Role for ${username}`}> 
      <div className="space-y-4">
        <select
          className="input-field"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">Select role</option>
          <option value="super-admin">Super-Admin</option>
          <option value="admin">Admin</option>
          <option value="qa">QA-Agent</option>
          <option value="call-agent">Call-Agent</option>
        </select>
        <div className="flex justify-end space-x-2 pt-2">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={() => role && onSubmit(role)} disabled={!role} className="btn-primary disabled:opacity-50">Set Role</button>
        </div>
      </div>
    </Modal>
  );
};

export default RoleModal;
